import { useAdminAuth } from './useAdminAuth'

export function usePermissions() {
  const { user } = useAdminAuth()

  const hasRole = (role: string | string[]) => {
    if (!user) return false
    const requiredRoles = Array.isArray(role) ? role : [role]
    return user.roles.some((userRole) => requiredRoles.includes(userRole))
  }

  const hasPermission = (permission: string) => {
    if (!user) return false
    return user.permissions.includes(permission)
  }

  const isSuperAdmin = () => hasRole('SuperAdmin')
  const isBillingAdmin = () => hasRole(['SuperAdmin', 'BillingAdmin'])
  const isSupportAdmin = () => hasRole(['SuperAdmin', 'SupportAdmin'])

  return {
    hasRole,
    hasPermission,
    isSuperAdmin,
    isBillingAdmin,
    isSupportAdmin,
  }
}
